import styled from 'styled-components';

export const AuditApptHeaderForm = styled.form`
  display: flex;
  column-gap: var(--s3);
`;
